// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8869ee41","633":"2e820bb6"}[chunkId] + ".chunk.js";
};